(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const films = new Map(), menus = new Map(), footers = new Map();
  const ui = () => JSON.parse(document.querySelector('[data-story285-ui]').textContent);
  const text = (key, label) => ui()[key].replace('[label]', label);

  function initialize() {
    document.querySelectorAll('[data-film]').forEach(frame => {
      if (films.has(frame)) return;
      const video = frame.querySelector('video'), button = frame.querySelector('button');
      const label = button.dataset.filmLabel, abort = new AbortController();
      const options = { signal: abort.signal };
      let userPaused = false, userEnabled = false, visible = false, failed = false;
      video.muted = true; video.defaultMuted = true;
      const sync = () => {
        if (failed) return;
        button.setAttribute('aria-pressed', String(!video.paused));
        button.setAttribute('aria-label', text(video.paused ? 'play' : 'pause', label));
      };
      const play = () => {
        if (failed || userPaused || (!userEnabled && reduce.matches) || document.hidden || !visible) return;
        if (!video.src) video.src = video.dataset.src;
        video.play().then(sync).catch(sync);
      };
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) play(); else video.pause();
      }, { threshold: .12 });
      observer.observe(frame);
      button.addEventListener('click', () => {
        if (failed) return;
        if (!video.paused) { userPaused = true; video.pause(); }
        else { userPaused = false; userEnabled = true; play(); }
      }, options);
      video.addEventListener('play', sync, options);
      video.addEventListener('pause', sync, options);
      video.addEventListener('loadeddata', play, options);
      video.addEventListener('error', () => {
        failed = true; video.removeAttribute('src'); video.load(); button.disabled = true;
        button.setAttribute('aria-label', text('unavailable', label));
        button.setAttribute('aria-pressed', 'false');
      }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); }, options);
      window.addEventListener('pageshow', play, options);
      reduce.addEventListener('change', () => { if (reduce.matches && !userEnabled) video.pause(); else play(); }, options);
      films.set(frame, () => { abort.abort(); observer.disconnect(); video.pause(); });
      sync();
    });
    const menu = document.querySelector('[data-r2-menu-dialog]'), opener = document.querySelector('[data-r2-menu-open]');
    if (menu && opener && !menus.has(menu)) {
      const abort = new AbortController(), options = { signal: abort.signal };
      opener.addEventListener('click', () => { menu.showModal(); opener.setAttribute('aria-expanded', 'true'); }, options);
      menu.querySelector('[data-r2-menu-close]')?.addEventListener('click', () => menu.close(), options);
      menu.addEventListener('close', () => { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }, options);
      menu.addEventListener('click', event => { if (event.target === menu) menu.close(); }, options);
      menus.set(menu, () => abort.abort());
    }
    const legal = document.querySelector('.r5-footer-legal');
    if (legal && !footers.has(legal)) {
      const wide = matchMedia('(min-width: 769px)'), abort = new AbortController();
      legal.open = wide.matches;
      wide.addEventListener('change', () => { legal.open = wide.matches; }, { signal: abort.signal });
      footers.set(legal, () => abort.abort());
    }
  }
  function cleanup(scope) {
    for (const registry of [films, menus, footers]) {
      for (const [node, dispose] of registry) {
        if (!node.isConnected || scope?.contains(node)) { dispose(); registry.delete(node); }
      }
    }
  }
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.('a[href^="#"]');
    if (!anchor) return;
    const target = document.getElementById(anchor.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduce.matches ? 'instant' : 'smooth', block: 'start' });
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    history.replaceState(null, '', anchor.hash);
  });
  document.addEventListener('shopify:section:unload', event => cleanup(event.target));
  document.addEventListener('shopify:section:load', () => { cleanup(); initialize(); });
  initialize();
})();
